<template>
  <footer>
    <p>北京艾西智酷科技有限公司 | Copyright ©2020 icpeixun.com | <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备190326638号-6</a></p>
    <p>电话：400-808-2093（工作日9:00-18:00）</p>
  </footer>
</template>

<script>
export default {
  name: "footers"
};
</script>
<style scoped>
footer {
  background-color: rgb(255, 255, 255);
  width: 100%;
  min-width: 1200px;
  height: 114px;
  font-size: 14px;
  color: #333;
  line-height: 30px;
  padding-top: 40px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/modules/footer.vue